import { useEffect, useState } from 'react';
import { getOwnSecretaryStatus } from '../services/classSecretaryService';

// `status` is null once loaded if the signed-in student isn't a class secretary.
export function useSecretaryStatus() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');

    getOwnSecretaryStatus()
      .then((result) => {
        if (mounted) setStatus(result);
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load your class secretary assignment');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { status, loading, error };
}
